export const getHHMMFormat = (date) => {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const time = `${hours}:${minutes}`;

  return time;
};

export const getDDMMFormat = (date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const dateStr = `${day}/${month}`;

  return dateStr;
};

export function parseValidDate(dateStr) {
  if (!dateStr || dateStr.startsWith("0000-00-00")) return null;
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
}

export function getDDMMHHmmFormat(date) {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return "Invalid date";
  }
  return `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(
    date.getMinutes()
  ).padStart(2, "0")}`;
}
